// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"352":"df1792424219b205","881":"b1df2d65c795aa71","888":"de661058e30562e7"}[chunkId] + ".css";
};